import InstanceApi from "@/services/apiClient.js";

const setAppProduct = (state, product) => {
  state.commit("SET_APP_PRODUCT_ID", product);
  state.commit("SET_APP_PRODUCT_LEGEND", product);
  state.commit("SET_APP_PRODUCT_DESCRIPTIONS", product);
  state.commit("SET_APP_PRODUCT_THUMBNAIL", product);
  state.commit("SET_APP_PRODUCT_GLOBALS", product);
  state.commit("SET_APP_PRODUCT_GALLERY", product);
  state.commit("SET_APP_PRODUCT_VIDEO", product);
  state.commit("SET_APP_PRODUCT_NOTICE", product);
  state.commit("SET_APP_PRODUCT_FLASH_SELL", product);
  state.commit("SET_APP_PRODUCT_SHIPPING_INFO", product);
  state.commit("SET_APP_PRODUCT_RELATED", product);
  state.commit("SET_APP_PRODUCT_SHIPPING_METHODS", product);
  state.commit("SET_APP_PRODUCT_OPTIONS", product);
  state.commit("SET_APP_PRODUCT_ESSENTIALS_OPTIONS", product);
  state.commit("SET_APP_PRODUCT_IS_IN_COMPARATOR", product);
  state.commit("SET_APP_PRODUCT_REDUCED_TAX_RATE", product);
  state.commit("SET_APP_PRODUCT_CAN_ADD_TO_COMPARATOR", product);
  state.commit("SET_APP_PRODUCT_REVIEWS", product);
  state.commit("SET_APP_PRODUCT_PRICE_INFO", product);
  state.commit("SET_APP_PRODUCT_CART_URL", product);
  state.commit("SET_APP_PRODUCT_PUSH_COM", product);
  state.commit("SET_APP_PRODUCT_CATEGORY_ID", product);
  state.commit("SET_APP_PRODUCT_AVAILABLE_FOR_RENTING", product);
  state.commit("SET_APP_PRODUCT_AVAILABLE_FOR_FINANCING", product);
  state.commit("SET_APP_PRODUCT_RETAILABLE", product);
  state.commit("SET_APP_PRODUCT_EXTENDED_WARRANTY", product);
  state.commit("SET_APP_PRODUCT_RENTING_PRICE", product);
  state.commit("SET_APP_PRODUCT_FINANCING_PRICE", product);
  state.commit("SET_APP_PRODUCT_ADDITIONAL_PRODUCT", product);
  state.commit("SET_APP_PRODUCT_RENTING_RELATED_PRODUCTS", product);
  state.commit("SET_APP_PRODUCT_IS_LEAD", product);
  state.commit("SET_APP_PRODUCT_IS_PAC", product);
  state.commit("SET_PAC_TYPE", product);
  state.commit("SET_APP_PRODUCT_ORIGINAL_TVA", product);
  state.commit("SET_SHARE_LINK_URL", product);
  state.commit("SET_LEAD_TYPE", product);
  state.commit("SET_ACCESSORY_PRODUCT", product);
  state.commit("SET_IS_RFID_CARD", product);
  state.commit("SET_BREADCRUMBS", product);
  state.commit("SET_SLOTS_CHOICE_ACTIVE", product);
  state.commit("SET_APP_PRODUCT_FORM_STRAPI_ID", product);
};

const setAppProductIdFormCart = (state, product) => {
  state.commit("SET_APP_PRODUCT_ID_FROM_CART", product);
};

// TOOGLE TVA FOR PARTICULAR CHECK
const setAppProductParticularTva = (state, particularTva) => {
  state.commit("SET_APP_PRODUCT_PARTICULAR_TVA", particularTva);
};

// SET OR RESET ORIGINAL TVA OF PRODUCT
const setAppProductOriginalTva = state => {
  state.commit("SET_APP_PRODUCT_ORIGINAL_TVA");
};

const setAppProductShippingIsTaxReducible = (state, isTaxReducible) => {
  state.commit("SET_APP_PRODUCT_SHIPPING_IS_TAX_REDUCIBLE", isTaxReducible);
};

const setAppProductShippingMethodSpecialPrice = (state, specialPrice) => {
  state.commit("SET_APP_PRODUCT_SHIPPING_METHOD_SPECIAL_PRICE", specialPrice);
};

const setAppProductBillInfo = (state, selectedMethods) => {
  state.commit("SET_APP_PRODUCT_BILL_INFO", selectedMethods);
};

const setAppProductRateTaxDeliveryClassic = (state, rateTaxDeliveryClassic) => {
    state.commit("SET_APP_PRODUCT_RATE_TAX_DELIVERY_CLASSIC", rateTaxDeliveryClassic);
};

const getConfigQuestions = async state => {
  const configQuestionsUrl = "configurateur/questions/get";
  try {
    const response = await InstanceApi.get(configQuestionsUrl);
    state.commit("SET_CONFIG_QUESTIONS", response.data);
  } catch (err) {
    console.error("getConfigQuestions failure", err);
    return { error: err };
  }
};

const setTvaProfils = (state, profils) => {
  state.commit("SET_TVA_PROFILS", profils)
};

const setProductUniverse = (state, universe) => {
    state.commit("SET_MCP_UNIVERSE", universe)
};

export default {
  setAppProduct,
  setAppProductParticularTva,
  setAppProductOriginalTva,
  setAppProductBillInfo,
  setAppProductShippingIsTaxReducible,
  setAppProductShippingMethodSpecialPrice,
  setAppProductIdFormCart,
  getConfigQuestions,
  setAppProductRateTaxDeliveryClassic,
  setTvaProfils,
  setProductUniverse,
};
